import { render, staticRenderFns } from "./card-image-crop-organization.vue?vue&type=template&id=e20dfca6&scoped=true&"
import script from "./card-image-crop-organization.vue?vue&type=script&lang=js&"
export * from "./card-image-crop-organization.vue?vue&type=script&lang=js&"
import style0 from "./card-image-crop-organization.vue?vue&type=style&index=0&id=e20dfca6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20dfca6",
  null
  
)

export default component.exports